import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { IonicStorageModule } from "@ionic/storage";
import { Device } from "@ionic-native/device";
import { AppVersion } from "@ionic-native/app-version";
import { SuperTabsModule, SuperTabsController } from '../components/ionic2-super-tabs/src';
import { ComponentsModule } from "../components/components.module";
import { Deeplinks } from "@ionic-native/deeplinks";
import { BLE } from "@ionic-native/ble";
import { Geolocation } from "@ionic-native/geolocation";
import { Flashlight} from "@ionic-native/flashlight";
import { NativeAudio } from "@ionic-native/native-audio";
import { MyApp } from './app.component';
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import { AboutPage } from '../pages/about/about';
import { ContactPage } from '../pages/contact/contact';
import { HomePage } from '../pages/home/home';
import { TabsPage } from '../pages/tabs/tabs';
import { LoginPage } from "../pages/login/login";
import { InfoModalPage } from "../pages/info-modal/info-modal";
import { NewsModalPage } from "../pages/news-modal/news-modal";
import { ProfilePage } from "../pages/profile/profile";
import { ChangePasswordPage } from "../pages/change-password/change-password";
import { CompanyUserTermsPage } from "../pages/company-user-terms/company-user-terms";
import { CompanyFilesPage } from "../pages/company-files/company-files";
import { NotificationsPage } from "../pages/notifications/notifications";
import { ReportPage } from "../pages/report/report";
import { ReportWorkorderPage } from "../pages/report-workorder/report-workorder";
import { ReportLocationPage } from "../pages/report-location/report-location";
import { ReportSearchLocationPage } from "../pages/report-search-location/report-search-location";
import { ReportSearchCustomerPage } from "../pages/report-search-customer/report-search-customer";
import { ReportCustomerClientPage } from "../pages/report-customer-client/report-customer-client";
import { ReportCustomerInvoicePage } from "../pages/report-customer-invoice/report-customer-invoice";
import { ReportCustomerExternalPage } from "../pages/report-customer-external/report-customer-external";
import { ReportFilesPage } from "../pages/report-files/report-files";
import { ReportEditPartPage } from "../pages/report-edit-part/report-edit-part";
import { ReportEditRepairPage } from "../pages/report-edit-repair/report-edit-repair";
import { ReportEditUnitPage } from "../pages/report-edit-unit/report-edit-unit";
import { ReportSelectUnitPage } from "../pages/report-select-unit/report-select-unit";
import { ReportSelectUnitbrandPage } from "../pages/report-select-unitbrand/report-select-unitbrand";
import { ReportMeasurementPage } from "../pages/report-measurement/report-measurement";
import { ReportMeasurementGetPage } from "../pages/report-measurement-get/report-measurement-get";
import { ReportMeasurementGetTestoBlePage } from "../pages/report-measurement-get-testo-ble/report-measurement-get-testo-ble";
import { ReportAddUnitPage } from "../pages/report-add-unit/report-add-unit";
import { ReportAddPartPage } from "../pages/report-add-part/report-add-part";
import { ReportAddRepairPage } from "../pages/report-add-repair/report-add-repair";
import { ReportApprovePhotoPage } from "../pages/report-approve-photo/report-approve-photo";
import { ReportSearchUnitmodelPage } from "../pages/report-search-unitmodel/report-search-unitmodel";
import { ReportChecklistPage } from "../pages/report-checklist/report-checklist";
import { ReportTermsPage } from "../pages/report-terms/report-terms";
import { ReportRepairsPage } from "../pages/report-repairs/report-repairs";
import { ReportSubmitPage } from "../pages/report-submit/report-submit";
import { ReportSurveyPage } from "../pages/report-survey/report-survey";
import { SearchUnitPage } from "../pages/search-unit/search-unit";
import { SearchPartPage } from "../pages/search-part/search-part";
import { SearchLocationUnitsPage } from "../pages/search-location-units/search-location-units";
import { SignaturePage } from "../pages/signature/signature";
import { ViewPhotoPage } from "../pages/view-photo/view-photo";
import { WorkordersPage } from "../pages/workorders/workorders";
import { UnitPage } from "../pages/unit/unit";
import { UnitOverviewPage } from "../pages/unit-overview/unit-overview";
import { UnitInfoPage } from "../pages/unit-info/unit-info";
import { UnitHistoryPage } from "../pages/unit-history/unit-history";
import { UnitReportsPage } from "../pages/unit-reports/unit-reports";

import { XpCompanyFilesPage } from "../pages/xp-company-files/xp-company-files";
import { XpHomePage } from "../pages/xp-home/xp-home";
import { XpNotificationsPage } from "../pages/xp-notifications/xp-notifications";
import { XpReportPage } from "../pages/xp-report/xp-report";
import { XpReportAddPartPage } from "../pages/xp-report-add-part/xp-report-add-part";
import { XpReportAddRepairPage } from "../pages/xp-report-add-repair/xp-report-add-repair";
import { XpReportCustomerClientPage } from "../pages/xp-report-customer-client/xp-report-customer-client";
import { XpReportFilesPage } from "../pages/xp-report-files/xp-report-files";
import { XpReportSelectUnitPage } from "../pages/xp-report-select-unit/xp-report-select-unit";
import { XpReportWorkorderPage } from "../pages/xp-report-workorder/xp-report-workorder";
import { XpReportMeasurementPage } from "../pages/xp-report-measurement/xp-report-measurement";
import { XpReportRepairsPage } from "../pages/xp-report-repairs/xp-report-repairs";
import { XpReportChecklistPage } from "../pages/xp-report-checklist/xp-report-checklist";
import { XpReportSearchLocationPage } from "../pages/xp-report-search-location/xp-report-search-location";
import { XpReportSubmitPage } from "../pages/xp-report-submit/xp-report-submit";
import { XpSearchUnitPage } from "../pages/xp-search-unit/xp-search-unit";
import { XpWorkordersPage } from "../pages/xp-workorders/xp-workorders";
import { XpTabsPage } from "../pages/xp-tabs/xp-tabs";
import { XpSearchLocationUnitsPage } from "../pages/xp-search-location-units/xp-search-location-units";
import { XpUnitPage } from "../pages/xp-unit/xp-unit";
import { XpUnitHistoryPage } from "../pages/xp-unit-history/xp-unit-history";
import { XpUnitInfoPage } from "../pages/xp-unit-info/xp-unit-info";
import { XpUnitOverviewPage } from "../pages/xp-unit-overview/xp-unit-overview";
import { XpUnitReportsPage } from "../pages/xp-unit-reports/xp-unit-reports";
import { XpReportAddUnitPage } from "../pages/xp-report-add-unit/xp-report-add-unit";
import { XpReportEditUnitPage } from "../pages/xp-report-edit-unit/xp-report-edit-unit";
import { XpGymHomePage } from "../pages/xp-gym-home/xp-gym-home";
import { XpPickMachinePage } from "../pages/xp-pick-machine/xp-pick-machine";


import { ApiService } from "../services/api.service";
import { GymDataService } from "../services/gym-data.service";
import { DataService } from "../services/data.service";
import { MeasurementService } from "../services/measurement.service";
import { ReportService } from "../services/report.service";
import { XpReportService } from "../services/xp-report.service";
import { WorkorderService } from "../services/workorder.service";
import { XpWorkorderService } from "../services/xp-workorder.service";
import { ActivityLogService } from "../services/activity-log.service";
import { UnitSearchHistoryService } from "../services/unit-search-history.service";
import { MruService } from "../services/mru.service";
import { Test300Service } from "../services/testo300.service";
import { TestoBleService } from "../services/testo-ble.service";
import { OneSignalService } from "../services/one-signal.service";
import { NotificationService } from "../services/notification.service";
import { FileService } from "../services/file.service";
import { GeolocationService } from "../services/geolocation.service";
import { FlashlightService } from "../services/flashlight.service";
import { BarcodeScannerService } from "../services/barcode-scanner.service";

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { WebIntent } from "@ionic-native/web-intent";
import { SignaturePadModule } from "angular2-signaturepad";
import { BarcodeScanner } from "@ionic-native/barcode-scanner";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { HTTP } from "@ionic-native/http";
import { Camera } from "@ionic-native/camera";
import { AppAvailability } from "@ionic-native/app-availability";
import { Chooser } from "@ionic-native/chooser";
import { DatePipe } from "@angular/common";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    MyApp,
    AboutPage,
    ContactPage,
    HomePage,
    TabsPage,
    LoginPage,
    InfoModalPage,
    NewsModalPage,
    ProfilePage,
    ChangePasswordPage,
    CompanyUserTermsPage,
    CompanyFilesPage,
    NotificationsPage,
    ReportPage,
    ReportAddUnitPage,
    ReportAddPartPage,
    ReportAddRepairPage,
    ReportApprovePhotoPage,
    ReportSearchUnitmodelPage,
    ReportWorkorderPage,
    ReportLocationPage,
    ReportSearchLocationPage,
    ReportSearchCustomerPage,
    ReportCustomerClientPage,
    ReportCustomerInvoicePage,
    ReportCustomerExternalPage,
    ReportFilesPage,
    ReportSelectUnitPage,
    ReportSelectUnitbrandPage,
    ReportMeasurementPage,
    ReportMeasurementGetPage,
    ReportMeasurementGetTestoBlePage,
    ReportEditPartPage,
    ReportEditRepairPage,
    ReportEditUnitPage,
    ReportChecklistPage,
    ReportTermsPage,
    ReportRepairsPage,
    ReportSubmitPage,
    ReportSurveyPage,
    SearchUnitPage,
    SearchPartPage,
    SearchLocationUnitsPage,
    SignaturePage,
    ViewPhotoPage,
    WorkordersPage,
    UnitPage,
    UnitOverviewPage,
    UnitInfoPage,
    UnitHistoryPage,
    UnitReportsPage,
    XpCompanyFilesPage,
    XpHomePage,
    XpNotificationsPage,
    XpReportPage,
    XpReportAddPartPage,
    XpReportAddRepairPage,
    XpReportCustomerClientPage,
    XpReportFilesPage,
    XpReportSelectUnitPage,
    XpReportWorkorderPage,
    XpReportMeasurementPage,
    XpReportRepairsPage,
    XpReportChecklistPage,
    XpReportSearchLocationPage,
    XpReportSubmitPage,
    XpReportAddUnitPage,
    XpReportEditUnitPage,
    XpSearchLocationUnitsPage,
    XpSearchUnitPage,
    XpUnitPage,
    XpUnitHistoryPage,
    XpUnitInfoPage,
    XpUnitOverviewPage,
    XpUnitReportsPage,
    XpWorkordersPage,
    XpTabsPage,
    XpGymHomePage,
    XpPickMachinePage
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp, {
      mode: 'ios',
      backButtonText: 'Terug'
    }),
    IonicStorageModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    SuperTabsModule,
    ComponentsModule,
    SignaturePadModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    AboutPage,
    ContactPage,
    HomePage,
    TabsPage,
    LoginPage,
    InfoModalPage,
    NewsModalPage,
    ProfilePage,
    ChangePasswordPage,
    CompanyUserTermsPage,
    CompanyFilesPage,
    NotificationsPage,
    ReportPage,
    ReportAddUnitPage,
    ReportAddPartPage,
    ReportAddRepairPage,
    ReportApprovePhotoPage,
    ReportSearchUnitmodelPage,
    ReportWorkorderPage,
    ReportLocationPage,
    ReportSearchLocationPage,
    ReportSearchCustomerPage,
    ReportCustomerClientPage,
    ReportCustomerInvoicePage,
    ReportCustomerExternalPage,
    ReportFilesPage,
    ReportSelectUnitPage,
    ReportSelectUnitbrandPage,
    ReportMeasurementPage,
    ReportMeasurementGetPage,
    ReportMeasurementGetTestoBlePage,
    ReportEditPartPage,
    ReportEditRepairPage,
    ReportEditUnitPage,
    ReportChecklistPage,
    ReportTermsPage,
    ReportRepairsPage,
    ReportSubmitPage,
    ReportSurveyPage,
    SearchUnitPage,
    SearchPartPage,
    SearchLocationUnitsPage,
    SignaturePage,
    ViewPhotoPage,
    WorkordersPage,
    UnitPage,
    UnitOverviewPage,
    UnitInfoPage,
    UnitHistoryPage,
    UnitReportsPage,
    XpCompanyFilesPage,
    XpHomePage,
    XpNotificationsPage,
    XpReportPage,
    XpReportAddPartPage,
    XpReportAddRepairPage,
    XpReportCustomerClientPage,
    XpReportFilesPage,
    XpReportSelectUnitPage,
    XpReportWorkorderPage,
    XpReportMeasurementPage,
    XpReportRepairsPage,
    XpReportChecklistPage,
    XpReportSearchLocationPage,
    XpReportSubmitPage,
    XpReportAddUnitPage,
    XpReportEditUnitPage,
    XpSearchLocationUnitsPage,
    XpSearchUnitPage,
    XpUnitPage,
    XpUnitHistoryPage,
    XpUnitInfoPage,
    XpUnitOverviewPage,
    XpUnitReportsPage,
    XpWorkordersPage,
    XpTabsPage,
    XpGymHomePage,
    XpPickMachinePage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    BarcodeScanner,
    Camera,
    Chooser,
    AppAvailability,
    InAppBrowser,
    HttpClient,
    HTTP,
    Device,
    Deeplinks,
    BLE,
    AppVersion,
    Geolocation,
    Flashlight,
    NativeAudio,
    DatePipe,
    SuperTabsController,
    WebIntent,
    ApiService,
    DataService,
    MeasurementService,
    ReportService,
    XpReportService,
    WorkorderService,
    XpWorkorderService,
    ActivityLogService,
    UnitSearchHistoryService,
    MruService,
    Test300Service,
    TestoBleService,
    OneSignalService,
    NotificationService,
    FileService,
    GeolocationService,
    FlashlightService,
    BarcodeScannerService,
    GymDataService,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts